// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9y-0";
export var optionCard = "_9y-1";